export default __webpack_public_path__ + "static/media/gl_6.10fa031b.mp3";